import { createActionCreator } from '@pressreader/appstore';
import type { IArticle, IArticleIssue } from '@pressreader/content-types';
import { AnyFeedCursor } from '@pressreader/feed-types';
import { IPoint } from '@pressreader/geometry';
import type { ArticleNavConfig } from '@pressreader/views-navigation';

import { MODULE_NAME } from '../../constants';
import { ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/common/`;

export const openTranslationMenuAction = createActionCreator<{
    articleId: string;
    cursor: AnyFeedCursor | null;

    language: IArticle['language'] | null;
    center?: IPoint;

    parentMenuId?: string;
}>(`${prefix}open-translation-menu`);

export const editArticleAction = createActionCreator<ArticleActionPayload>(`${prefix}edit-article`);

export const deleteArticleAction = createActionCreator<ArticleActionPayload>(`${prefix}delete-article`);

export const translateArticleAction = createActionCreator<{
    articleId: string;
    languageCode: IArticle['language'];
    cursor: AnyFeedCursor | null;
}>(`${prefix}translate-article`);

interface CancelArticleTranslationInArticleViewPayload extends ArticleActionPayload {
    cursor?: AnyFeedCursor;
    languageCode?: IArticle['language'];
}
export const cancelArticleTranslationInArticleView = createActionCreator<
    | CancelArticleTranslationInArticleViewPayload
    | {
          navConfig: Partial<ArticleNavConfig> & { lang?: IArticle['language']; articleId: IArticle['id'] };
      }
>(`${prefix}cancel-article-translation-in-article-view`);

export const resetArticleTranslation = createActionCreator<Pick<CancelArticleTranslationInArticleViewPayload, 'articleId' | 'languageCode'>>(
    `${prefix}reset-article-translation`,
);

export const cancelArticlesInIssueTranslationAction = createActionCreator<{
    issueKey: IArticleIssue['issueKey'];
    languageCode?: IArticle['language'];
}>(`${prefix}cancel-articles-in-issue-translation-action`);

export const requestArticleAccessAction = createActionCreator<ArticleActionPayload>(`${prefix}request_article_access_action`);
export const purchaseArticleBegan = createActionCreator<ArticleActionPayload>(`${prefix}purchase_article_began`);
export const purchaseArticleDone = createActionCreator<ArticleActionPayload>(`${prefix}purchase_article_done`);
export const purchaseArticleFailed = createActionCreator<ArticleActionPayload>(`${prefix}purchase_article_failed`);

export const articleAccessGranted = createActionCreator<ArticleActionPayload>(`${prefix}article_access_granted`);
